<script>

import { Overlay } from '../../'

export default {
    name: 'LinReg',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'Mano', version: '1.0.0',
                desc: 'Linear Regression Channels',
                preset: {
                    name: 'LinReg $length $deviation',
                    side: 'onchart',
                    settings: {
                        lineWidth: 0.75,
                        color: '#4c8dffab',
                        showMid: true,
                        backColor: '#4c8dff0a'
                    }
                }
            }
        },
        use_for() { return ['LinReg'] },
        calc() {
            return {
                props: {
                    length: { def: 100, text: 'Length' },
                    deviation: { def: 2, text: 'StdDev' },
                    use_tr: { def: true, text: 'Use True Range' },
                },
                conf: { renderer: 'Channel' },
                update: `let mid = linreg(close, length, 0)
                    let width = use_tr ? atr(length)[0] : stdev(close, length)[0]
                    return [mid[0] + deviation * width, mid[0], mid[0] - deviation * width]`,
            }
        }
    }
}
</script>
